import React, { useEffect } from "react";
import Navbar from "../components/common/Navbar";
import Breadcrumb from "../components/common/Breadcrumb";
import ContactDetails from "../components/contact/ContactDetails";
import Footer from "../components/other/Footer";
import GetInTouchButton from "../components/about/GetInTouchButton";

export default function ContactPage() {
  useEffect(() => {
    document.title = "Contact | Agreya Capital";
  }, []);

  return (
    <>
      {/* Header */}
      <header className="header-area">
        <Navbar />
      </header>

      {/* Main Content */}
      <main id="main-content">
        <GetInTouchButton />
        {/* Breadcrumb */}
        {/* <Breadcrumb title="Contact Us." /> */}

        {/* Contact Details */}
        <ContactDetails />
      </main>

      {/* Footer */}
      {/* <Footer /> */}
    </>
  );
}
